import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
  // This hook gets the current page's URL path
  const { pathname } = useLocation();

  // This effect runs every time the URL path changes
  useEffect(() => {
    // This command instantly scrolls the window to the top left (coordinates 0, 0)
    window.scrollTo(0, 0);
  }, [pathname]);

  // This component doesn't render anything itself, it just returns its children
  return children;
};

export default ScrollToTop;